<template>
  <div class="app">
    <AppHeader fixed>
      <b-link class="navbar-brand-mobile" to="#">
        <img class="navbar-brand-full" src="img/brand/logo.svg" width="89" height="25" alt="CoreUI Logo">        
      </b-link>  
      <SidebarToggler class="d-lg-none" display="md" mobile /> 

      <select id="projectSwitcher" @change="onChangeProject($event)" >
          <option v-bind:key="project.id" v-for="project in projectsList" :value="project.id" :selected="project.selected">{{project.name}}</option>
      </select>  
        
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="img/brand/logo.svg" width="89" height="25" alt="CoreUI Logo">
        <img class="navbar-brand-minimized" src="img/brand/logo.svg" width="89" height="25" alt="CoreUI Logo">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="d-md-down-none ml-auto">
        <b-nav-item class="d-md-down-none">
         
        </b-nav-item>
      </b-navbar-nav>                  
      <AsideToggler ref="fileInput" class="hidden d-none d-lg-block usermenu"/>        
     <div class="usernotifystatus">
      <CustomLogout/>
      <div v-if="userIsSubscribed">                
          <font-awesome-icon icon="bell" class="cicon isnotify" title="Notifiche abilitate"/>                 
        </div> 
        <div v-else-if="! userIsSubscribed">
          <font-awesome-icon icon="bell-slash" class="cicon isnotify" title="Notifiche non abilitate"/>         
        </div>           
        <font-awesome-icon icon="user" class="navbar-toggler cicon" @click="setToggle"/> 
      </div>
            
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav  :navItems="navItems"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">        
        <Breadcrumb hidden :list="list"/>        
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>      
      <AppAside fixed>        
        <DefaultAside/>
      </AppAside>      
    </div>
      <TheFooter hidden>
      <div>
        <a href="https://coreui.io">CoreUI</a>
        <span class="ml-1">&copy; 2018 creativeLabs.</span>
      </div>
      <div class="ml-auto">
        <span class="mr-1">Powered by</span>
        <a href="https://coreui.io">CoreUI for Vue</a>
      </div>
    </TheFooter>    
  </div>
</template>

<script>
import Vue from 'vue'
import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdown from './DefaultHeaderDropdown'

import DefaultContainerRepository from './../repositories/DefaultContainerRepository'
import CustomLogout from './../components/CustomLogout'

export default {
    mixins: [DefaultContainerRepository], 
    name: 'DefaultContainer',
    components: {
      AsideToggler,
      AppHeader,
      AppSidebar,
      AppAside,
      TheFooter,
      Breadcrumb,
      DefaultAside,
      DefaultHeaderDropdown,
      SidebarForm,
      SidebarFooter,
      SidebarToggler,
      SidebarHeader,
      SidebarNav,
      SidebarMinimizer,
      CustomLogout
    },
    data () {
      return {
        navItems: nav.items,
        userIsSubscribed:false,          
        projectsList:[],      
        currentProjectID :0
      }
    }            
}

</script>
<style scoped>
#projectSwitcher{
    float: left;
    display: block;
    position: inherit;
    margin-left: 64px;
}

.app-header .navbar-brand {
    position: absolute;
    top: 0;
    left: 50%;
    margin-left: -77.5px;
}
</style>